// "Not provided by the client" (ticket 072, W10): one compact card above the two columns, only
// when there are gaps. One line per item with a tag; Not assessed lines carry their impact.
import React from 'react'
import { SourceCardHeader } from './BriefParts'
import { ADVISOR_INTAKE_GAPS_TITLE, ADVISOR_INTAKE_GAP_TAGS } from '../../../lib/advisorIntakeModel'

const TAG_CLASS = {
  [ADVISOR_INTAKE_GAP_TAGS.notAssessed]: 'brief-gap-tag--not-assessed',
  [ADVISOR_INTAKE_GAP_TAGS.skipped]: 'brief-gap-tag--skipped',
  [ADVISOR_INTAKE_GAP_TAGS.notSure]: 'brief-gap-tag--not-sure',
}

export function GapsCard({ gaps }) {
  if (!gaps || gaps.length === 0) return null
  return (
    <div className="brief-source-card brief-gaps">
      <SourceCardHeader title={ADVISOR_INTAKE_GAPS_TITLE} />
      <div className="brief-source-card-body">
        <ul className="brief-gap-list">
          {gaps.map((g) => (
            <li key={g.key} className="brief-gap-row">
              <span className={`brief-gap-tag ${TAG_CLASS[g.tag] || ''}`}>{g.tag}</span>
              <span className="brief-gap-text">
                {g.label}
                {g.impact && <span className="u-desc-xs"> {g.impact}</span>}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
